import { render, staticRenderFns } from "./GetDistribute.vue?vue&type=template&id=d24a72d0&scoped=true"
import script from "./GetDistribute.vue?vue&type=script&lang=js"
export * from "./GetDistribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24a72d0",
  null
  
)

export default component.exports